import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fahrenheitToCelsius',
    standalone: false
})
export class FahrenheitToCelsiusPipe implements PipeTransform {
  transform(value: number): string {
    const celcius = (value - 32) * (5 / 9);
    const rounded = Math.round(celcius * 10) / 10;
    if (rounded === Math.floor(rounded)) {
      return rounded.toFixed(0);
    }
    return rounded.toFixed(1);
  }
}
